import { render, staticRenderFns } from "./SSECMethod2.vue?vue&type=template&id=a64014da&"
import script from "./SSECMethod2.vue?vue&type=script&lang=js&"
export * from "./SSECMethod2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports